import axios from "../../api/axiosInstance";
import { STATUS, getProjectId, extractErrorInfo } from "./sharedfunction";

/**
 * Create a new execution session
 * @param {Object} params - Parameters
 * @param {string|null} [params.testcase_id=null] - The test case ID
 * @param {string|null} [params.launch_id=null] - The launch ID
 * @param {string} params.mode - Execution mode
 * @returns {Promise<Object>} Response with status and data
 */
export async function createExecutionSession({ testcase_id = null, launch_id = null, mode } = {}) {
  try {
    const projectId = getProjectId();

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/${projectId}/execution-session`,
      { testcase_id, launch_id, mode },
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response.data.data,
        message: response.data.message,
      };
    }
    return { status: STATUS.ERROR, error: response?.data?.message || "Failed to create session" };
  } catch (error) {
    return extractErrorInfo(error);
  }
}

/**
 * Update an existing execution session
 * @param {Object} params - Parameters
 * @param {string} params.sessionId - The execution session ID
 * @param {boolean} [params.is_completed] - Whether the session is completed
 * @param {boolean} [params.is_successful] - Whether the session was successful
 * @param {string} [params.testcase_id] - The test case ID
 * @returns {Promise<Object>} Response with status and data
 */
export async function updateExecutionSession({ sessionId, is_completed, is_successful, testcase_id } = {}) {
  try {
    const projectId = getProjectId();

    const body = {};
    if (is_completed !== undefined) body.is_completed = is_completed;
    if (is_successful !== undefined) body.is_successful = is_successful;
    if (testcase_id !== undefined) body.testcase_id = testcase_id;

    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/${projectId}/execution-session/${sessionId}`,
      body,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response.data.data,
        message: response.data.message,
      };
    }
    return { status: STATUS.ERROR, error: response?.data?.message || "Failed to update session" };
  } catch (error) {
    return extractErrorInfo(error);
  }
}
